import { dsClass } from '../../../common/constants/dsClasses.js';
import {
  additionalServicesMsg,
  elisaMatkapuhelinvastaajaMsg,
  internetConnectionMsg,
  t,
  voiceAndTextMessagesMsg,
} from '../../../common/i18n/index.js';
import { OfferSpecifications } from '../../HorizontalSubscriptionCard/OfferSpecifications.js';
import { getDefaultModalSpecifications } from '../../ProductOfferingsCardCoCo/ProductOfferingsCardContentCoCo/ProductOfferingCardContentUtils.js';
import type { ProductModalContentProps } from '../../ProductOfferingsCardCoCo/ProductOfferingsCardContentCoCo/types.js';

export const getMobileVoiceModalContent = ({ productOffering, activePopoverRef }: ProductModalContentProps) => {
  const modalSpecs = getDefaultModalSpecifications(productOffering);

  return [
    {
      title: t.VY1K(voiceAndTextMessagesMsg),
      content: (
        <OfferSpecifications specifications={modalSpecs.voiceAndTextSpecs} activePopoverRef={activePopoverRef} />
      ),
    },
    {
      title: t.LXSR(additionalServicesMsg),
      content: (
        <>
          <p className={dsClass.TEXT_XS}>{elisaMatkapuhelinvastaajaMsg}</p>
          <p className={dsClass.TEXT_XS}>{t.EH0U('Elisa Mobiiliturva for companies')}</p>
        </>
      ),
    },
    ...(modalSpecs.has5gPlus
      ? [
          {
            title: t.B10B(internetConnectionMsg),
            content: (
              <OfferSpecifications specifications={modalSpecs.internetSpecs} activePopoverRef={activePopoverRef} />
            ),
          },
          {
            title: '5G+',
            content: (
              <p className={dsClass.TEXT_XS}>
                {t.A504(
                  `5G+ subscriptions always use the best available connection. In areas without 5G coverage, they switch to 4G network instead. Using a 5G+ subscription can cut delay times by half. The new 5G+ technology also saves your phone's battery, which makes it a more energy-efficient option.`
                )}
              </p>
            ),
          },
        ]
      : []),
  ];
};
